import { render, staticRenderFns } from "./Generic_Translations.vue?vue&type=template&id=056e84ca&scoped=true&"
import script from "./Generic_Translations.vue?vue&type=script&lang=js&"
export * from "./Generic_Translations.vue?vue&type=script&lang=js&"
import style0 from "./Generic_Translations.vue?vue&type=style&index=0&id=056e84ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e84ca",
  null
  
)

export default component.exports